import { useMemo } from "react";
import { formatForClipboard, preformatCustomText, preformatPassageText } from "../../utils/formatter";
import { isPassageText, OutputElement, PassageText } from "../../utils/outputElement";
import { CustomText } from "../../utils/inputRow";
import { SlideOptionsData } from "../SlideOptions";
import PassageSeparator from "./PassageSeparator";
import SlideText from "./SlideText";
import CopyButton from "./CopyButton";

interface Props {
  outputElements: OutputElement[];
  slideOptionsData: SlideOptionsData;
}

const SlideResults = ({ outputElements, slideOptionsData }: Props) => {
  const preformattedTexts = useMemo(
    () =>
      outputElements.map((e) =>
        !isPassageText(e)
          ? preformatCustomText(e as CustomText, slideOptionsData)
          : preformatPassageText(e as PassageText, slideOptionsData)
      ),
    [outputElements, slideOptionsData]
  );

  const clipboardText = useMemo(
    () => formatForClipboard(preformattedTexts, slideOptionsData.referenceAbove),
    [preformattedTexts, slideOptionsData.referenceAbove]
  );

  const elements: JSX.Element[] = preformattedTexts.flatMap((pt, i) => [
    <PassageSeparator
      key={`separator-${i}`}
      label={pt.reference === "" ? (slideOptionsData.upperCase ? "CUSTOM TEXT" : "Custom Text") : pt.reference}
    />,
    ...pt.slideTexts.map((st, j) => {
      const refLine = slideOptionsData.referenceAbove ? pt.reference : "";
      const textLine = st.join("\n").trim();
      return <SlideText key={`slide-${i}-${j}`} content={refLine + (refLine ? "\n" : "") + textLine} />;
    }),
  ]);

  return (
    <div className="m-2 md:m-5 p-2 md:p-5 border rounded">
      <div className="flex items-center mb-2">
        <h2 className="text-xl text-slate-900">Slides:</h2>
        <div className="flex-grow"></div>
        <CopyButton textToCopy={clipboardText} />
      </div>
      <div className="px-2 lg:px-8 xl:px-10 pb-10">{elements}</div>
    </div>
  );
};

export default SlideResults;
